import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const HistoryPage = lazy(() => import('../pages/history/page'));
const ProductionEquipmentPage = lazy(() => import('../pages/equipment/production/page'));
const WeldingEquipmentPage = lazy(() => import('../pages/equipment/welding/page'));
const CapabilityPage = lazy(() => import('../pages/equipment/capability/page'));
const MaterialsPage = lazy(() => import('../pages/equipment/materials/page'));
const OrganizationPage = lazy(() => import('../pages/organization/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/history',
    element: <HistoryPage />,
  },
  {
    path: '/equipment/production',
    element: <ProductionEquipmentPage />,
  },
  {
    path: '/equipment/welding',
    element: <WeldingEquipmentPage />,
  },
  {
    path: '/equipment/capability',
    element: <CapabilityPage />,
  },
  {
    path: '/equipment/materials',
    element: <MaterialsPage />,
  },
  {
    path: '/organization',
    element: <OrganizationPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
